import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth, arrowWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_RED } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track8CRed = ({ state, workState, onLabelClick }) => (
	<g id="Track8CRed" transform="translate(1918.000000, 648.000000)" className="track">
		<g id="line" transform="translate(0.000000, 0.980478)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)} strokeLinecap="round"
			 strokeWidth={tracksWidth}
		>
			<path
				d="M4.26325641e-14,13 C12.0628127,5.2478477 27.7449756,6.14244728 38.8479484,15.2161075 L40.4599316,16.5334652 L40.4599316,16.5334652"/>
			<line x1="61.1997442" y1="33.4826206" x2="131.886312" y2="90.1631578"/>
			<TrackArrow transform="translate(38.929706, 15.112405) rotate(-145.000000) translate(-38.929706, -15.112405) "
									points="42.9297058 23.1124053 34.9297058 15.1124053 42.9297058 7.1124053"/>
		</g>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track8CRed')}
			coords="47.000000, 15.980478"
			text="8C"
			textCoordsX="10.0610352"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
		/>
	</g>
);

Track8CRed.propTypes = trackPropTypes;

export default Track8CRed;
